module.exports = __webpack_public_path__ + "static/media/play2.56f3065b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/play2.png
// module id = 2072
// module chunks = 6